import Box from '@mui/material/Box';
import classNames from 'classnames';
import Grid from '@mui/material/Grid';
import makeClasses from 'hooks/useClasses';
import PropTypes from 'prop-types';
import React from 'react';
import styles from 'styles/jss/components/bookSizeDialogStyle';
import Typography from '@mui/material/Typography';

const SectionWrapper = ({
  children, sx, altBackground, gridClassName, title, subTitle, className
}) => {
  const classes = makeClasses(styles);

  return (
    <Box
      className={classNames(classes.contentSection, className, {
        altBackround: altBackground
      })}
      sx={{
        ...sx
      }}
    >
      <Grid
        container
        item
        maxWidth="lg"
        className={gridClassName}
        spacing={0}
      >
        {title && (
          <Grid item className="stepBox" textAlign="center">
            <Typography
              component="h1"
              className="sectionTitle"
              variant="bookPreview"
            >
              {title}
            </Typography>
            {subTitle && (
              <Typography component="p">
                {subTitle}
              </Typography>
            )}
          </Grid>
        )}
        {children}
      </Grid>
    </Box>
  );
};

SectionWrapper.defaultProps = {
  altBackground: false,
  sx: {},
  gridClassName: '',
  className: '',
  title: undefined,
  subTitle: undefined
};

SectionWrapper.propTypes = {
  altBackground: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape()
  ]),
  gridClassName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape()
  ]),
  sx: PropTypes.shape(),
  title: PropTypes.string,
  subTitle: PropTypes.string
};

export default SectionWrapper;
